import React, { useEffect, useState } from "react";

export const FeedBack = () => {
    const feedbacks = [
        {
            rating: 4,
            name: "John Doe",
            company: "ABC Industries",
            feedback:
                "Vetri Pipeline Systems provided us with an exceptional solution that exceeded our expectations.",
        },
        {
            rating: 5,
            name: "Arun Kumar",
            company: "VTS Corp",
            feedback:
                "Excellent service and very professional team. Highly recommended!",
        },
        {
            rating: 4,
            name: "Priya S",
            company: "Nova Tech",
            feedback:
                "Good quality and timely delivery. Very satisfied with the service.",
        },
    ];

    const [current, setCurrent] = useState(0);

    // Auto Slide Every 3 Seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrent((prev) => (prev + 1) % feedbacks.length);
        }, 3000); // 3000ms = 3 seconds

        return () => clearInterval(interval);
    }, [feedbacks.length]);

    return (
        <div className="max-w-4xl mx-auto ">
            <div className="rounded-xl p-8 text-center transition-all duration-700">
                {/* Stars */}
                <div className="flex justify-center mb-4">
                    {Array.from({ length: feedbacks[current].rating }).map((_, i) => (
                        <span key={i} className="text-primary-500 text-xl">★</span>
                    ))}
                </div>

                {/* Feedback */}
                <p className="text-gray-600 text-lg mb-6">
                    "{feedbacks[current].feedback}"
                </p>

                {/* User */}
                <h3 className="font-semibold text-xl">
                    {feedbacks[current].name}
                </h3>
                <p className="text-sm text-gray-500">
                    {feedbacks[current].company}
                </p>
            </div>

            {/* Dots */}
            <div className="flex justify-center gap-2 mt-4">
                {feedbacks.map((_, i) => (
                    <span
                        key={i}
                        className={`h-3 w-3 rounded-full ${i === current ? "bg-secondary-950" : "bg-gray-300"
                            }`}
                    />
                ))}
            </div>
        </div>
    );
};